import defaultBgImage from 'assets/dog-being-checked-by-the-vet-at-the-pet-shop2.png';
import companyBgImage from 'assets/images/company-login.png';
import tutorBgImage from 'assets/images/tutor-login.png';

export const TitleByUserRole = {
  admin: 'Área do Administrador',
  partner: 'Área do Parceiro',
  vet: 'Área do Veterinário',
  tutor: 'Área do Tutor',
  company: 'Área do RH',
};

export const AuthImageByUserRole = {
  admin: defaultBgImage,
  partner: defaultBgImage,
  vet: defaultBgImage,
  tutor: tutorBgImage,
  company: companyBgImage,
};

export type IUserRole = 'admin' | 'vet' | 'partner' | 'tutor' | 'company';

export interface ISignIn {
  cpf: string;
  email: string;
  password: string;
  role: IUserRole;
  captchaToken: string;
}

export interface IRequestRecoveryPassword {
  cpf: string;
  email: string;
  role: IUserRole;
}

export interface IRecoveryPassword {
  token: string;
  password: string;
  passwordConfirmation: string;
  role: IUserRole;
}

export interface ISignInResponse {
  expireAt: number;
  token: string;
}

export interface IPartnerPreRegistration {
  email: string;
  password: string;
  passwordConfirmation: string;
  acceptTerms: {
    acceptedDate?: Date;
    isAccepted: boolean;
  };
  representativeCode?: string;
}
